module.exports = __webpack_public_path__ + "img/wave.fb3c1e81.gif";